// extracted by mini-css-extract-plugin
export default {"component":"AddServiceWithRole_component__b1xu6","dropdownName":"AddServiceWithRole_dropdownName__XfgPQ","darkMode":"AddServiceWithRole_darkMode__Zj2v9"};